import cn from 'classnames';
import { useNavigate } from 'react-router-dom';
import { PathProps } from './UniversalSidebar';

interface SidebarPlatformsProps extends PathProps {
    isExpanded: boolean;
    neutral?: boolean;
}

export function SidebarPlatforms({ Icon, label, path, isExpanded }: SidebarPlatformsProps) {
    const navigate = useNavigate();
    const pathname = location.pathname;

    return (
        <div
            onClick={() => {
                navigate(path);
            }}
            className={cn('w-full flex items-center py-3 rounded-md cursor-pointer transition-colors duration-50', {
                ['bg-brand-primary text-brand-neutral-200']: pathname === path,
                ['hover:bg-brand-primary']: pathname !== path,
                ['px-4 gap-3']: isExpanded,
                ['justify-center']: !isExpanded
            })}>
            <Icon className="w-5 h-5" />
            <span
                className={cn(`whitespace-nowrap overflow-hidden transition-all duration-200`, {
                    ['opacity-100 w-auto']: isExpanded,
                    ['opacity-0 w-0']: !isExpanded
                })}>
                {label}
            </span>
        </div>
    );
}
